import React from "react";
import { TooltipComponent, Button } from "../../Component";
import { isPendingStatus } from "./medicalPartnerListTableHelpers";

const MedicalPartnerListRowTools = ({
  rowId,
  item,
  onOpenDossier,
  onConfirmDelete,
  onConfirmApprove,
}) => {
  const pending = isPendingStatus(item);
  return (
    <div className="d-flex w-100 justify-content-end">
      <ul className="nk-tb-actions gx-1 flex-nowrap justify-content-end mb-0">
        <li>
          <TooltipComponent
            id={`partner-workspace-${rowId}`}
            tag="a"
            href="#workspace"
            containerClassName="btn btn-trigger btn-icon"
            icon="eye"
            direction="top"
            text="Open partner workspace — full dossier with profile editing"
            onClick={(e) => {
              e.preventDefault();
              onOpenDossier(item._id);
            }}
          />
        </li>
        {pending ? (
          <li className="d-flex align-items-center">
            <Button
              color="success"
              size="sm"
              type="button"
              className="medical-partner-list__approve-btn text-white"
              aria-label="Approve partner"
              title="Approve partner — activate workflow after confirmation"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onConfirmApprove(item);
              }}
            >
              Approve
            </Button>
          </li>
        ) : null}
        {typeof onConfirmDelete === "function" ? (
          <li>
            <TooltipComponent
              id={`partner-delete-${rowId}`}
              tag="a"
              href="#delete"
              containerClassName="btn btn-trigger btn-icon text-danger"
              icon="delete"
              direction="top"
              text="Delete partner"
              onClick={(e) => {
                e.preventDefault();
                onConfirmDelete(item._id);
              }}
            />
          </li>
        ) : null}
      </ul>
    </div>
  );
};

export default MedicalPartnerListRowTools;
